import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiOwnerTone } from '../../types/ui-owner-tone.type';

@Component({
  selector: 'ui-avatar',
  imports: [],
  templateUrl: './ui-avatar.component.html',
  styleUrl: './ui-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAvatarComponent {
  public readonly initials: InputSignal<string> = input.required<string>();
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly tone: InputSignal<UiOwnerTone> = input<UiOwnerTone>('neutral');
  public readonly size: InputSignal<number> = input<number>(28);
}
